// Services
import callAPI from "../callApi";
import path from "../variables";

/**
 * Sessions de caisse — ouverture/clôture/audit/PDF.
 * Backend : App\Http\Controllers\v1\Accounting\CashierSessionController.
 *
 * Note : tous les endpoints sont gated par feature.accounting.cash_register
 * + permission cashier-session:<action>.
 */
const CashierSession = {
	list: async (filter?: string) =>
		await callAPI(
			"GET",
			`${path.base}/cashier-sessions${filter ?? ""}`,
			"",
			"listing cashier sessions"
		),

	current: async (stationId: number | string) =>
		await callAPI(
			"GET",
			`${path.base}/cashier-sessions/current?station_id=${stationId}`,
			"",
			"getting current cashier session"
		),

	get: async (uuid: string) =>
		await callAPI("GET", `${path.base}/cashier-sessions/${uuid}`, "", "getting cashier session"),

	open: async (data: { station_id: number | string; opening_float: number; notes?: string }) =>
		await callAPI("POST", `${path.base}/cashier-sessions`, data, "opening cashier session"),

	close: async (uuid: string, data: { declared_total: number; notes?: string }) =>
		await callAPI(
			"POST",
			`${path.base}/cashier-sessions/${uuid}/close`,
			data,
			"closing cashier session"
		),

	approve: async (uuid: string, data: { notes?: string }) =>
		await callAPI(
			"POST",
			`${path.base}/cashier-sessions/${uuid}/approve`,
			data,
			"approving cashier session"
		),

	reopen: async (uuid: string, data: { reason: string }) =>
		await callAPI(
			"POST",
			`${path.base}/cashier-sessions/${uuid}/reopen`,
			data,
			"reopening cashier session"
		),

	// URL utilisée par l'attribut `href` d'un <a download> pour
	// déclencher le téléchargement dans le navigateur (le PDF est
	// streamé en réponse, pas du JSON). L'auth header est porté par
	// l'intercepteur Axios si on passe par callAPI, mais pour
	// `download` on préfère un <a> direct + token cookie/session.
	pdfUrl: (uuid: string) => `${path.base}/cashier-sessions/${uuid}/pdf`,

	// Fallback : téléchargement via fetch + blob (pour les cas où
	// l'auth header est nécessaire — Bearer token sur Authorization).
	downloadPdf: async (uuid: string) =>
		await callAPI(
			"GET",
			`${path.base}/cashier-sessions/${uuid}/pdf`,
			"",
			"downloading cashier session PDF",
			{ responseType: "blob" }
		),
};

export default CashierSession;
